import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/RefundPolicy.css'; // Ensure this CSS file includes the necessary styles

const RefundPolicy = () => {
  return (
    <div className="refund-policy-page">
      <Helmet>
        <title>Refund Policy | Woodland Escape </title>
        <meta 
          name="description" 
          content="Read the refund and cancellation policy for Woodland Escape . Learn about our terms and conditions regarding bookings, cancellations, and liabilities." 
        />
        <meta 
          name="keywords" 
          content="Woodland Escape , Refund Policy, Cancellation, Terms and Conditions, Liability, Booking Policy" 
        />
      </Helmet>


<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
           <h1>Refund and Cancellation Policy</h1>
    </div>
  </div>
</section>

   
      <section className="refund-policy-section">
        <div className="container">
          <div className="row">
            {/* Refund Policy Content */}
            <div className="col-lg-9 refund-policy-content">
              <h3 className='darkcolor'>Cancellation and Refunds</h3>
              <p>
                Once a booking or reservation is confirmed at 
                <strong> www.woodlandescape.com </strong>, it cannot be 
                cancelled, postponed, transferred, or refunded. We kindly request 
                guests to verify all details before confirming their stay or event booking.
              </p>

              <h4 className='darkcolor'>Breach of Terms</h4>
              <p>
                In the event of a breach of our Terms of Service, Privacy Policy, or 
                other guidelines, Woodland Escape  reserves the right to take 
                necessary actions, including suspension or termination of bookings, 
                and initiate legal proceedings where applicable.
              </p>

              <h4 className='darkcolor'>Indemnity</h4>
              <p>
                Guests agree to indemnify and hold harmless Woodland Escape  
                and its affiliates from claims, damages, or liabilities arising out 
                of violations of our terms or misuse of services.
              </p>

              <h4 className='darkcolor'>Applicable Law</h4>
              <p>
                This policy is governed by the laws of India. All disputes shall 
                fall under the exclusive jurisdiction of the courts in Pune, 
                Maharashtra, India.
              </p>

              <h4 className='darkcolor'>Copyright Complaint</h4>
              <p>
                If you believe that any content on our website infringes your 
                copyright, please contact us at: 
                <a href="mailto:woodlandescape01@gmail.com"> woodlandescape01@gmail.com</a>.
              </p>

              <h4 className='darkcolor'>Risk of Loss</h4>
              <p>
                The risk of loss for services or items booked passes to the guest 
                once the confirmation is issued or items are delivered to the carrier.
              </p>

              <h4 className='darkcolor'>Limitation of Liability</h4>
              <p>
                Woodland Escape  shall not be held liable for direct, indirect, 
                or consequential damages arising from the use of our website, 
                booking system, or services. We do not guarantee uninterrupted 
                access, error-free functionality, or that the website will be free 
                from harmful components.
              </p>
            </div>

            {/* Optional Image Section */}
            {/* <div className="col-lg-4">
              <div className="image-container">
                <img src="/images/refund-policy.jpg" alt="Refund Policy" className="refund-policy-image" />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
